
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

export default {




props: {
title: String,
loading: {
type: Boolean,
dafault: false
}
},
components: {
InlineLoading
}
}



// WEBPACK FOOTER //
// ./src/components/button.vue